module.exports = __webpack_public_path__ + "img/greyTick.8bc975f4.svg";